export default {
	defaultParameters: {
		parameters: {
			recommendedMaximumLength: 600,
			slightlyTooMany: 600,
			farTooMany: 700,
		},
		applicableIfTextLongerThan: 600,
	},
	cornerstoneParameters: {
		parameters: {
			recommendedMaximumLength: 500,
			slightlyTooMany: 500,
			farTooMany: 600,
		},
		applicableIfTextLongerThan: 500,
	},
};
